import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InfoBubbleComponent } from './info-bubble.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [CommonModule, SharedModule],
  declarations: [InfoBubbleComponent],
  exports: [InfoBubbleComponent]
})

export class InfoBubbleModule {
}



// WEBPACK FOOTER //
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/info-bubble/info-bubble.module.ts